import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { useTheme, SxProps } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

// Components
import Typography from 'Components/ds/Typography';
import Feature from 'Pages/SignupLogin/Feature';

const styles: { [key: string]: SxProps } = {
  animation: {
    opacity: 0, // Set initial opacity to 0
    transform: 'translateY(0px)', // Set initial transform to match the starting state of the animation
    animationDuration: '800ms',
    animationTimingFunction: 'ease',
    animationDelay: '800ms',
    animationName: 'slidein',
    animationFillMode: 'forwards',
  },
  animationTitle: {
    '@keyframes slideinTitle': {
      from: {
        opacity: 0,
        transform: 'translateY(10px)',
      },
      to: {
        opacity: 1,
        transform: 'translate(0px)',
      },
    },
    animationName: 'slideinTitle',
  },
  animationFeature1: {
    '@keyframes slideinFeture1': {
      from: {
        opacity: 0,
        transform: 'translateY(24px)',
      },
      to: {
        opacity: 1,
        transform: 'translate(0px)',
      },
    },
    animationName: 'slideinFeture1',
  },
  animationFeature2: {
    '@keyframes slideinFeture2': {
      from: {
        opacity: 0,
        transform: 'translateY(30px)',
      },
      to: {
        opacity: 1,
        transform: 'translate(0px)',
      },
    },
    animationName: 'slideinFeture2',
  },
  animationFeature3: {
    '@keyframes slideinFeture3': {
      from: {
        opacity: 0,
        transform: 'translateY(46px)',
      },
      to: {
        opacity: 1,
        transform: 'translate(0px)',
      },
    },
    animationName: 'slideinFeture3',
  },
  carousel: {
    pt: 5,
    pb: 5,
    flexGrow: 1,
    '.react-multi-carousel-dot-list': {
      position: 'relative',
      marginTop: '24px',
      '.react-multi-carousel-dot': {
        display: 'flex',
        alignItems: 'center',
        button: {
          backgroundColor: 'rgba(255, 255, 255, 0.5)',
          border: 'none',
          width: '3px',
          height: '3px',
        },
      },
      '.react-multi-carousel-dot--active button': {
        backgroundColor: 'rgba(255, 255, 255, 1)',
        width: '6px',
        height: '6px',
      },
    },
  },
};

const Features = () => {
  const { breakpoints } = useTheme();
  const isDesktopDevice = useMediaQuery(breakpoints.up('md'));

  const features = [
    {
      title: 'High Yield',
      text: 'Institutional lending opportunities fully backed by liquid digital assets',
      sx: { ...styles.animation, ...styles.animationFeature1 },
    },
    {
      title: 'Risk Management ',
      text: 'Lending to premium institutions with transparent terms and security',
      sx: { ...styles.animation, ...styles.animationFeature2 },
    },
    {
      title: 'Customer Service',
      text: 'Sophisticated application with best in class experience and onboarding',
      sx: { ...styles.animation, ...styles.animationFeature3 },
    },
  ];

  if (isDesktopDevice)
    return (
      <Stack spacing={3}>
        <Typography
          variant='h1'
          color='ds.text.contrast'
          weight='bold'
          sx={{ ...styles.animation, ...styles.animationTitle } as any}
        >
          Access Institutional Yield
        </Typography>
        <Stack spacing={1}>
          {features.map(({ title, text, sx }) => (
            <Feature key={title} title={title} text={text} sx={sx} />
          ))}
        </Stack>
      </Stack>
    );

  return (
    <Box sx={styles.carousel}>
      <Carousel
        responsive={{ mobile: { breakpoint: { max: 4000, min: 0 }, items: 1 } }}
        arrows={false}
        renderArrowsWhenDisabled={false}
        renderButtonGroupOutside={false}
        showDots
        renderDotsOutside
      >
        {features.map(({ title, text }) => (
          <Feature key={title} title={title} text={text} />
        ))}
      </Carousel>
    </Box>
  );
};

export default Features;
